<div class="hello-books" *ngIf="siteSlug === 'hello-books'">
  <div class="logo"></div>
  <div class="header"></div>
</div>
<div class="new-in-books-header" *ngIf="siteSlug === 'new-in-books'">
  <img loading="async" 
    src="https://storage.googleapis.com/wwm-static-content/new-in-books-header.png" 
    alt="https://storage.googleapis.com/wwm-static-content/new-in-books-header.png">
</div>
<section class="fs3-content" id="fs3" *ngIf="siteAdvert">
  <div class="heading">
    <div class="app-html-block" *ngIf="siteAdvert.headerHTML" [innerHtml]="siteAdvert.headerHTML"></div>
    <app-html-block *ngIf="!siteAdvert.headerHTML" [blockArray]="siteAdvert.headerContent"></app-html-block>
  </div>

  <div class="content" *ngIf="!isFBAdCampaign">
    <h3>Pick a date for your promotion</h3>
    <p>Pick one to proceed</p>
    <p>Cost: {{siteAdvert.price | currency:'USD'}}</p>
    <div class="date-picker-wrapper">
      <app-pub-date-picker 
      [siteAdvert]="siteAdvert._id" 
      [availableTo]="availableTo" 
      [move]="false"
      (unavailableToFree)="displayUnavailableToFreeModal()"
    ></app-pub-date-picker>
    </div>
  </div>

  <div class="content" *ngIf="isFBAdCampaign">
    <h3>Pick a <u>start</u> date for your promotion</h3>
    <div class="date-picker-wrapper">
      <app-pub-date-picker 
        [siteAdvert]="siteAdvert._id" 
        [availableTo]="availableTo" 
        [move]="false" 
        (unavailableToFree)="displayUnavailableToFreeModal()"
      ></app-pub-date-picker>
    </div>
  </div>

  <div class="footer">
    <div class="app-html-block" *ngIf="siteAdvert.footerHTML" [innerHtml]="siteAdvert.footerHTML"></div>
    <app-html-block *ngIf="!siteAdvert.footerHTML" [blockArray]="siteAdvert.footerContent"></app-html-block>
  </div>
</section>
<app-membership-modal 
  [userNotLogged]="userNotLogged" 
  [modalId]="'modal-promo'"
  [authorLink]="authorLink"
  [hideButtonText]="hideButtonText"
  [learnMoreButton]="true"
  [buttonText]="'Upgrade'"
  [text]="text" [subText]="subText"
  (confirmChoice)="upgrade($event)"
></app-membership-modal>
